import { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ArrowLeft, Loader2 } from 'lucide-react'
import Logo from '../components/Logo'

export function SatispayPaymentPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const orderId = searchParams.get('orderId')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // TODO: Implementare integrazione reale con Satispay
    // Per ora simuliamo un redirect
    setTimeout(() => {
      setLoading(false)
    }, 1000)
  }, [])

  const handleMockPayment = () => {
    // Simulazione pagamento Satispay
    navigate(`/payment-success?orderId=${orderId}`)
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-100">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Logo size={36} variant="full" />
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition"
          >
            <ArrowLeft size={20} />
            <span>Indietro</span>
          </button>
        </div>
      </header>

      {/* Main Content */}
      <div className="max-w-2xl mx-auto px-4 py-8">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Title */}
          <div className="bg-gradient-to-r from-red-600 to-orange-600 text-white px-8 py-6">
            <div className="flex items-center gap-3 mb-2">
              <div className="text-3xl">📱</div>
              <h1 className="text-3xl font-bold">Pagamento Satispay</h1>
            </div>
            <p className="text-red-100">Completa il pagamento con l'app Satispay</p>
          </div>

          <div className="p-8">
            {loading ? (
              <div className="text-center py-12">
                <Loader2 className="w-12 h-12 animate-spin text-red-600 mx-auto mb-4" />
                <p className="text-gray-600">Preparazione pagamento...</p>
              </div>
            ) : (
              <div className="text-center">
                <div className="bg-orange-50 border-2 border-orange-200 rounded-xl p-8 mb-6">
                  <div className="text-6xl mb-4">🚧</div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-2">
                    Integrazione in Sviluppo
                  </h2>
                  <p className="text-gray-600 mb-6">
                    L'integrazione con Satispay è in fase di sviluppo.
                    <br />
                    Per ora puoi simulare un pagamento.
                  </p>
                </div>

                {/* Mock Payment Button */}
                <button
                  onClick={handleMockPayment}
                  className="w-full bg-red-600 text-white py-4 px-6 rounded-lg font-semibold hover:bg-red-700 transition flex items-center justify-center gap-2 mb-4"
                >
                  <span>📱</span>
                  <span>Simula Pagamento Satispay</span>
                </button>

                <button
                  onClick={() => navigate(-1)}
                  className="w-full bg-gray-100 text-gray-700 py-3 px-6 rounded-lg font-semibold hover:bg-gray-200 transition"
                >
                  Torna Indietro
                </button>

                {/* Info Box */}
                <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-4 text-left">
                  <h3 className="font-semibold text-blue-900 mb-2">ℹ️ Prossimi Passi</h3>
                  <ul className="text-sm text-blue-700 space-y-1">
                    <li>• Configurare API Satispay</li>
                    <li>• Implementare creazione pagamento</li>
                    <li>• Gestire callback di conferma</li>
                    <li>• Testare flusso completo</li>
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SatispayPaymentPage
